/**
 * @typedef {Object} RowName
 * @property {string} system_key
 * @property {string} name
 */

/**
 * RowName の配列から、"name" の配列を返す
 * @param {RowName[]} rowNames
 * @returns {string[]}
 */
export function getValueRowNames(rowNames) {
  return rowNames.map(setting => setting.name);
}

/**
 * RowName の配列から、指定された "name" に対応する "system_key" を返す
 * @param {string} name
 * @param {RowName[]} rowNames
 * @returns {string|null}
 */
export function getSystemKeyByName(name, rowNames) {
  const item = rowNames.find(setting => setting.name === name);
  if (item) {
    return item.system_key;
  }
  return null;
}
